module.exports = __webpack_public_path__ + "71394c0c7ad6c1e7d5c77e8ac292fba5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Pe-icon-7-stroke.eot
// module id = 71
// module chunks = 0